import SelectAncestorView from './select-ancestor-scorecard-step'
import ReportFilterUtil from './report-filter-util'

export default {
	titleCode: 'report.selectScorecardItem',
	view: SelectAncestorView,
	validate: function (attrs, opts) {
		return !ReportFilterUtil.hasAncestorValues(attrs, 'scorecardNodeIds')
	}
}
